import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAddresses } from '../store/addressSlice';
import { fetchPodTypes } from '../store/podTypeSlice';
import { createPod, fetchPods } from '../store/podSlice';
import AddressSelector from '../components/AddressSelector';
import PodTypeSelector from '../components/PodTypeSelector';
import toast from 'react-hot-toast';
const NewPod = () => {
  const dispatch = useDispatch();
  const { pods } = useSelector((state) => state.pods);
  const { success, error, isLoading } = useSelector((state) => state.pods);

  const [form, setForm] = useState({
    podname: '',
    isActive: true,
    addressId: '',
    podTypeId: '',
    addressText: '',
    podTypeText: '',
  });

  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(fetchAddresses());
    dispatch(fetchPodTypes());
    dispatch(fetchPods());
  }, [dispatch]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      podname: form.podname,
      isActive: form.isActive,
      addressId: form.addressId,
      podTypeId: form.podTypeId,
    };
    if (payload.podname && payload.addressId && payload.podTypeId) {
      dispatch(createPod(payload));
      setForm({
        podname: '',
        isActive: true,
        addressId: '',
        podTypeId: '',
        addressText: '',
        podTypeText: '',
      });
    }
  };

  useEffect(() => {
    if (success) {
      toast.success('✅ Pod created successfully!');
    }
    if (error) {
      toast.error(`❌ ${error}`);
    }
  }, [success, error]);

  const handleAddressSelect = (address) => {
    setForm({
      ...form,
      addressId: address.id,
      addressText: `${address.addressline1}, ${address.city}`,
    });
  };

  const handlePodTypeSelect = (podType) => {
    setForm({
      ...form,
      podTypeId: podType.id,
      podTypeText: podType.podtype,
    });
  };

  const filteredPods = pods.filter((p) =>
    p.podname.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-10 px-6">
      <div className="max-w-3xl bg-white rounded shadow p-6 mx-auto space-y-4">
        <h2 className="text-2xl font-bold mb-4">New Pod</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="podname"
            placeholder="Pod Name"
            value={form.podname}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded"
            required
          />

<div>
  <label className="block text-sm font-medium text-gray-600 mb-1">Address</label>
  <div className="flex gap-2">
    <input
      type="text"
      readOnly
      value={form.addressText}
      className="w-full px-4 py-2 border rounded bg-gray-100 cursor-not-allowed"
    />
    <AddressSelector onSelect={handleAddressSelect} />
  </div>
</div>

<div>
  <label className="block text-sm font-medium text-gray-600 mb-1">Pod Type</label>
  <div className="flex gap-2">
    <input
      type="text"
      readOnly
      value={form.podTypeText}
      className="w-full px-4 py-2 border rounded bg-gray-100 cursor-not-allowed"
    />
    <PodTypeSelector onSelect={handlePodTypeSelect} />
  </div>
</div>

          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
          >
            Create Pod
          </button>
        </form>
      </div>

      <div className="mt-6">
        <input
          type="text"
          placeholder="Search pod name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border px-4 py-2 rounded w-full"
        />
      </div>

      <table className="w-full border mt-4">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 text-left">Pod Name</th>
            <th className="p-2 text-left">Pod Type</th>
            <th className="p-2 text-left">Address</th>
          </tr>
        </thead>
        <tbody>
          {filteredPods.map((pod) => (
            <tr key={pod.id} className="border-t">
              <td className="p-2">{pod.podname}</td>
              <td className="p-2">{pod.podType?.podtype}</td>
              <td className="p-2">{pod.address?.addressline1}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NewPod;
